import { NgModule } from '@angular/core';
import { PageLoadProgressComponent } from './page-load-progress.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [PageLoadProgressComponent],
  imports: [CommonModule],
  exports: [PageLoadProgressComponent],
})
export class PageLoadProgressModule {}
